import type { ServiceChecklist } from '@obraplan/core/domain/quality/service-checklist';

/**
 * Para cada serviço, as checklists que o incluem (RN-297).
 *
 * O vínculo mora na ficha — `serviceIds`, desde a `0023` — e a pergunta do cadastro do
 * serviço é a inversa: "de que fichas eu faço parte?". Um serviço pode estar em mais de uma
 * (as fichas de alvenaria e de vergas, por exemplo), e a ordem é a do catálogo de fichas,
 * que a leitura já entrega ordenada. Serviço sem ficha não entra no mapa — quem lê trata a
 * ausência como "Sem checklist".
 *
 * Só nome, código e situação: é o que o formulário mostra, e é só leitura.
 */
export interface ServiceChecklistLink {
  readonly id: string;
  readonly name: string;
  readonly code?: string | undefined;
  readonly isActive: boolean;
}

export function checklistsByService(
  checklists: readonly ServiceChecklist[],
): Map<string, ServiceChecklistLink[]> {
  const byService = new Map<string, ServiceChecklistLink[]>();
  for (const checklist of checklists) {
    for (const serviceId of checklist.serviceIds) {
      const list = byService.get(serviceId) ?? [];
      list.push({
        id: checklist.id,
        name: checklist.name,
        code: checklist.code,
        isActive: checklist.isActive,
      });
      byService.set(serviceId, list);
    }
  }
  return byService;
}
